import styled from "styled-components";

export const BookingStepWidgetStyled = styled.div`
  display: flex;
  align-items: center;
  .step_item {
    display: flex;
    align-items: center;

    .step_circle {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      font-weight: 400;
      color: #000;
      border: 1px solid #000;
      box-sizing: border-box;

      &.yellow {
        background-color: #fff500;
      }
      &.orange {
        background-color: #ff8900;
      }
      &.purple {
        background-color: #4b42a8;
        color: #fff;
      }
      &.green {
        background-color: #3f830d;
        color: #fff;
      }

      &.active {
        font-weight: 600;
        border: 4px solid #000;
      }
    }

    .step_line {
      width: 40px;
      height: 1px;
      background-color: #000;
    }
  }

  &.theme_table {
    .step_circle {
      width: 22px;
      height: 22px;
      font-size: 12px;
      &.active {
        font-weight: 600;
        border: 3px solid #000;
      }
    }
    .step_line {
      width: 22px;
    }
  }
`;
